import styled from '@emotion/styled';
import { Constants, Theme } from '@seedlang/constants';
import Button from 'components/button/button';
import InPlaceSelect from 'components/form/in_place_select';
import ReviewCreateNote from 'components/review/review_create_note';
import { CharacterLimit, FieldLabel, StyledTextarea } from 'components/review/review_create_styles';
import { observer } from 'mobx-react';
import React from 'react';

const Form = styled.div`
`;

const FormGroup = styled.div`
  margin: ${props => props.margin || '0 0 20px 0'};
`;

const SwapFieldRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
`;

@observer
class ReviewCreateCustom extends React.Component {
  render() {
    return (
      <Form>
        <FormGroup>
          <FieldLabel
            name='review_custom_front'
            label={this.props.showAddWord ? 'Target Word' : 'Front of Card'}
          />
          <SwapFieldRow>
            <StyledTextarea
              value={this.props.frontText}
              onChange={e => this.props.onSetFrontText(e.target.value)}
              maxLength={Constants.REVIEW_CARD_MAX_FRONT_TEXT_LENGTH}
            />
            <Button
              background={Theme.blue}
              backgroundOnActive={Theme.blueGray}
              color='#FFF'
              border='none'
              borderRadius='50%'
              height='32px'
              width='32px'
              padding='2px 0 0 0'
              margin='0'
              tabIndex={-1}
              disabled={this.props.swapDisabled}
              onClick={this.props.swapFrontAndBack}
              iconMarginRight='0'
              flex='0 0 auto'
              justifyContent='center'
            >
              <i
                className='fa fa-arrow-down'
                style={{ fontSize: 13 }}
                aria-hidden='true'
              />
            </Button>
          </SwapFieldRow>
          {
            this.props.frontText.length > Constants.REVIEW_CARD_CHARACTER_LIMIT_DISPLAY_THRESHOLD &&
            <CharacterLimit warning={this.props.frontText.length >= Constants.REVIEW_CARD_MAX_FRONT_TEXT_LENGTH}>
              {this.props.frontText.length}/{Constants.REVIEW_CARD_MAX_FRONT_TEXT_LENGTH} characters
            </CharacterLimit>
          }
        </FormGroup>
        <FormGroup>
          <FieldLabel
            name='review_custom_back'
            label={this.props.showAddWord ? 'English Translation' : 'Back of Card'}
          />
          <SwapFieldRow>
            <StyledTextarea
              value={this.props.backText}
              onChange={e => this.props.onSetBackText(e.target.value)}
              maxLength={Constants.REVIEW_CARD_MAX_BACK_TEXT_LENGTH}
            />
            <Button
              background={Theme.blue}
              backgroundOnActive={Theme.blueGray}
              color='#FFF'
              border='none'
              borderRadius='50%'
              height='32px'
              width='32px'
              padding='0'
              margin='0'
              tabIndex={-1}
              disabled={this.props.swapDisabled}
              onClick={this.props.swapFrontAndBack}
              iconMarginRight='0'
              flex='0 0 auto'
              justifyContent='center'
            >
              <i
                className='fa fa-arrow-up'
                style={{ fontSize: 13 }}
                aria-hidden='true'
              />
            </Button>
          </SwapFieldRow>
          {
            this.props.backText.length > Constants.REVIEW_CARD_CHARACTER_LIMIT_DISPLAY_THRESHOLD &&
            <CharacterLimit warning={this.props.backText.length >= Constants.REVIEW_CARD_MAX_BACK_TEXT_LENGTH}>
              {this.props.backText.length}/{Constants.REVIEW_CARD_MAX_BACK_TEXT_LENGTH} characters
            </CharacterLimit>
          }
        </FormGroup>
        <FormGroup>
          <ReviewCreateNote
            showReviewNoteInput={this.props.showReviewNoteInput}
            note={this.props.note}
            onSetNote={this.props.onSetNote}
            onShowReviewNoteInput={this.props.onShowReviewNoteInput}
          />
        </FormGroup>
        <FieldLabel
          name='review_custom_deck'
          label='Review Deck'
        />
        <InPlaceSelect
          allowUpdate
          options={this.props.reviewDeckOptions}
          value={this.props.deckId}
          onChange={val => this.props.onSetDeckId(val)}
        />
      </Form>
    );
  }
}

export default ReviewCreateCustom;
